module.exports = __webpack_public_path__ + "static/img/total-num.35986ef3.png";